<div [copoScroller]="{restoreAfterViewInit: false}" #scroller="copoScroller" class="sidenav-content copo-card-with-title-and-button-bar" @routeAnimation>

	<ng-template #loading>
		<copo-loading-spinner *ngIf="!isError"></copo-loading-spinner>
	</ng-template>

	<ng-container *ngIf="!isLoading && !isError && selectedTemplate else loading">

		<!-- title -->
		<div class="card-title-block copo-offer-wizard-navigation-bar">
			<copo-back-button></copo-back-button>
			<div class="card-title-subblock">
				<div class="card-title-label margin-r50">{{title}}</div>
			</div>

			<div *ngIf="isSimulationInProgress" class="copo-offer-flex-container-row">
				<copo-loading-spinner class="copo-offer-center-vertical copo-offer-spinner-no-padding"></copo-loading-spinner>
				<span translate class="copo-offer-center-vertical">product.template.isbeingsimulated</span>
			</div>

			<div class="buttons-group">
				<!-- save button -->
				<button
					type="button" mat-flat-button 
					(click)="evtSubmitTemplateProduct(false)"
					[disabled]="!hasUserSubmitterRole || readOnlyUser"
					class="group-width group-button"
				>
					<span class="copo-offer-add-title" translate>product.save.template.product</span>
					<mat-icon iconPositionEnd svgIcon="plus_button" class="red-icon"></mat-icon>
				</button>
				<button
					type="button" mat-flat-button color="primary"
					(click)="evtSubmitTemplateProduct(true)"
					[disabled]="!hasUserSubmitterRole || isAddToCartDisabled()"
					class="group-width group-button"
				>
					<span class="copo-offer-add-title" translate>add.to.cart.label</span>
				</button>
			</div>
		</div>

		<!-- Template Selector-->
		<div class="copo-container">
			<div class="card-block">
				<mat-form-field class="copo-offer-margin-inside-block">
					<mat-label translate>product.template</mat-label>
					<mat-select
						(selectionChange)="evtTemplateChanged($event)"
						[disabled]="isLoading"
						[value]="selectedTemplate.templateNumber"
					>
						<mat-option
							*ngFor="let template of templates"
							[value]="template.templateNumber"
							[matTooltip]="template.customerTemplateReference"
						>
							{{template.customerTemplateReference}}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>

		<!-- template error messages -->
		<div *ngIf="configurationErrors.length > 0" class="copo-container">
			<div class="card-block copo-notification-block">
				<mat-icon svgIcon="alert" [attr.title]="'quapp.alert' | translate" class="copo-notification-icon"></mat-icon>
				<div class="copo-offer-flex-container-col">
					<div *ngFor="let message of configurationErrors" class="card-infos copo-notification-message-line">
						{{message}}
					</div>
				</div>
			</div>
		</div>

		<!-- content -->
		<copo-product-card-content [productFieldsObs]="getProductFieldsObs()"></copo-product-card-content>
	</ng-container>
</div>
